<div class="form__block">
  <div class="heading heading_standard heading_centered">
    Billing information
  </div>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="countryIdFC"
      [validationErrors]="{
        required: 'Please, select country',
      }"
    >
      <label class="hidden" for="country">Choose country</label>
      <select [formControl]="countryIdFC" autocomplete="country" id="country">
        <option [ngValue]="null">Choose country</option>
        @for (country of countries$ | async; track country.id) {
          <option [ngValue]="country.id">
            {{ country.name }}
          </option>
        }
      </select>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="nameFC"
      [validationErrors]="{
        required: 'Please, enter name',
      }"
    >
      <input
        [formControl]="nameFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="given-name"
        id="billing_name"
      />
      <label for="billing_name">Name</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="surnameFC"
      [validationErrors]="{
        required: 'Please, enter surname',
      }"
    >
      <input
        [formControl]="surnameFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="family-name"
        id="billing_surname"
      />
      <label for="billing_surname">Surname</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="addressFC"
      [validationErrors]="{
        required: 'Please, enter address',
      }"
    >
      <input
        [formControl]="addressFC"
        type="text"
        placeholder=""
        maxlength="100"
        autocomplete="street-address"
        id="billing_address"
        #billingAddress
      />
      <label for="billing_address">Address</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="addressInfoFC"
      [validationErrors]="{
        required: 'Please, enter dept., floor, building, etc.',
      }"
    >
      <input
        [formControl]="addressInfoFC"
        type="text"
        placeholder=""
        maxlength="100"
        autocomplete="address-line1"
        id="billing_address_info"
      />
      <label for="billing_address_info">Dept., floor, building, etc.</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="zipCodeFC"
      [validationErrors]="{
        required: 'Please, enter zip code',
      }"
    >
      <input
        [formControl]="zipCodeFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="postal-code"
        id="billing_zip_code"
      />
      <label for="billing_zip_code">Zip code</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="cityFC"
      [validationErrors]="{
        required: 'Please, enter city',
      }"
    >
      <input
        [formControl]="cityFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="address-level2"
        id="billing_city"
      />
      <label for="billing_city">City</label>
      <ng-template [appErrorsHost] />
    </div>

    @if (extendedForm) {
      <span class="cursor-pointer fields__option" (click)="toggleAsCompany()">
        {{ asCompanyFC.value ? 'Buy as a Private?' : 'Buy as a Company?' }}
      </span>
      @if (asCompanyFC.value) {
        <div class="fields__company">
          <div
            class="fields__item fields__item_full"
            [appIfInvalid]="companyNameFC"
            [validationErrors]="{
              required: 'Please enter company name',
            }"
          >
            <input
              [formControl]="companyNameFC"
              type="text"
              placeholder=""
              maxlength="100"
              autocomplete="organization"
              id="billing_company_name"
            />
            <label for="billing_company_name">Company Name</label>
            <ng-template [appErrorsHost] />
          </div>

          <div
            class="fields__item fields__item_full"
            [appIfInvalid]="registrationNumberFC"
            [validationErrors]="{
              required: 'Please enter company registration number',
            }"
          >
            <input
              [formControl]="registrationNumberFC"
              type="text"
              placeholder=""
              maxlength="50"
              autocomplete="off"
              id="billing_registration_number"
            />
            <label for="billing_registration_number">Registration Number</label>
            <ng-template [appErrorsHost] />
          </div>

          <div
            class="fields__item fields__item_full"
            [appIfInvalid]="legalAddressFC"
            [validationErrors]="{
              required: 'Please enter legal address',
            }"
          >
            <input
              [formControl]="legalAddressFC"
              type="text"
              placeholder=""
              maxlength="255"
              autocomplete="street-address"
              id="billing_legal_address"
            />
            <label for="billing_legal_address">Legal Address</label>
            <ng-template [appErrorsHost] />
          </div>
        </div>
      }
    }
  </div>
</div>
